import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import Saperator from '../Saperator'
import CardCarousel from '../CardCarousel'
import {Offerings} from '../../json/Json'
import { Card, CardBody, CardText, CardTitle } from 'reactstrap';


const OurOfferings = () => {
  return (
    <Container>
        <div id='section-ourOfferings' className='section-ourOfferings'>
            <div className="cc-heading-a text-center"> Our Offerings </div>

            <div className='mobile-only'>
              <CardCarousel jsonData={Offerings} forLg={3} forSm={1} heightClass={'h-99'}/>
            </div>

            <Row className='ourOfferings desktop-only'>
              {Offerings?.map((data, index)=> (
                <Col md={4} className='mb-4'>
                  <div className='px-2'>
                    <Card key={index}>
                      <img alt="Card" src={data.imgSrc} height={'270px'}/>
                      <CardBody>
                          <CardTitle className='cc-primary-color text-center' tag="h5">{data.cardTitle}</CardTitle>
                          <CardText className={`cc-small-text h-99`}>{data.cardText}</CardText>
                      </CardBody>
                    </Card>
                  </div>
                </Col>
              ))}
            </Row>

        </div>
        <Saperator/>
    </Container>
  )
}

export default OurOfferings